import { ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { envConfig } from '#app/config';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function absoluteUrl(path: string) {
  return `${envConfig.appUrl}${path}`;
}

export const formatZapsValue = (value?: number): string | number | undefined => {
  if (!value) return value;
  if (value >= 1000) {
    const kValue = value / 1000;
    return kValue % 1 === 0 ? `${kValue}k` : `${kValue.toFixed(1)}k`;
  }
  return value;
};
